'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debounce = require('just-debounce-it');

var index$1 = require('../message/index.js');

var index = require('../utils/index.js');

var constants = require('../constants.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debounce__default = /*#__PURE__*/_interopDefaultLegacy(debounce);

var MsgQueue = /*#__PURE__*/function () {
  function MsgQueue(selfPeerId, otherPeerId, network) {
    _classCallCheck(this, MsgQueue);

    this.peerId = otherPeerId;
    this.network = network;
    this.refcnt = 1;
    this._entries = [];
    this._log = index.logger(selfPeerId, 'msgqueue');
    this.sendEntries = debounce__default["default"](this._sendEntries.bind(this), constants.wantlistSendDebounceMs);
  }

  _createClass(MsgQueue, [{
    key: "addMessage",
    value: function addMessage(msg) {
      if (msg.empty) {
        return;
      }

      this.send(msg);
    }
  }, {
    key: "addEntries",
    value: function addEntries(entries) {
      this._entries = this._entries.concat(entries);
      this.sendEntries();
    }
  }, {
    key: "_sendEntries",
    value: function _sendEntries() {
      if (!this._entries.length) {
        return;
      }

      var msg = new index$1.BitswapMessage(false);

      this._entries.forEach(function (entry) {
        if (entry.cancel) {
          msg.cancel(entry.cid);
        } else {
          msg.addEntry(entry.cid, entry.priority);
        }
      });

      this._entries = [];
      this.addMessage(msg);
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(msg) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.network.connectTo(this.peerId);

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                this._log.error('cant connect to peer %s: %s', this.peerId.toB58String(), _context.t0.message);

                return _context.abrupt("return");

              case 9:
                this._log('sending message to peer %s', this.peerId.toB58String());

                this.network.sendMessage(this.peerId, msg).catch(function (err) {
                  _this._log.error('send error: %s', err.message);
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }]);

  return MsgQueue;
}();

exports.MsgQueue = MsgQueue;